module.exports = __webpack_public_path__ + "media/images/ic_subscribed-to-98435bb50561412ddc1d84fad26b2bf0.svg";